export const todo = {
  no: "序号",
  todoType: "待办事项",
  time: "时间",
  dueTime: "到期日",
  details: "详情",
  goto: "操作",
  driverCertExpireTips: "{0}的驾照到期日为 {1}",
  vehicleMaintTips: "设备编号【{0}】的保养到期日为 {1}",
  vehicleCheckTips: "设备编号【{0}】的年检到期日为 {1}",
  repairToCloseTips: "设备编号【{0}】的维修单号【{1}】维保中，请去小程序处理",
  repairToApproveTips: "设备编号【{0}】的维修单号【{1}】审批中",
  RepairToModifyTips: "设备编号【{0}】的维修单号【{1}】待补充",
  maintToCloseTips: "设备编号【{0}】的保养单号【{1}】维保中，请去小程序处理",
  maintToApprovalTips: "设备编号【{0}】的保养单号【{1}】审批中",
  maintToModifyTips: "设备编号【{0}】的保养单号【{1}】待补充",
};
